import script from "./DynamicZoom.vue?vue&type=script&setup=true&lang=ts"
export * from "./DynamicZoom.vue?vue&type=script&setup=true&lang=ts"

import "./DynamicZoom.vue?vue&type=style&index=0&id=6cdad98c&lang=sass"

const __exports__ = script;

export default __exports__